module.exports = __webpack_public_path__ + "static/media/add-proposal-requests.f5795166.svg";